import { Uniform1i, Uniform1f, Uniform4f, UniformMatrix4f } from '../uniform_binding';
const terrainPreludeUniforms = (context, locations) => ({
    'u_depth': new Uniform1i(context, locations.u_depth),
    'u_terrain': new Uniform1i(context, locations.u_terrain),
    'u_terrain_dim': new Uniform1f(context, locations.u_terrain_dim),
    'u_terrain_matrix': new UniformMatrix4f(context, locations.u_terrain_matrix),
    'u_terrain_unpack': new Uniform4f(context, locations.u_terrain_unpack),
    'u_terrain_exaggeration': new Uniform1f(context, locations.u_terrain_exaggeration)
});
const terrainUniforms = (context, locations) => ({
    'u_matrix': new UniformMatrix4f(context, locations.u_matrix),
    'u_texture': new Uniform1i(context, locations.u_texture),
    'u_ele_delta': new Uniform1f(context, locations.u_ele_delta)
});
const terrainDepthUniforms = (context, locations) => ({
    'u_matrix': new UniformMatrix4f(context, locations.u_matrix),
    'u_ele_delta': new Uniform1f(context, locations.u_ele_delta)
});
const terrainCoordsUniforms = (context, locations) => ({
    'u_matrix': new UniformMatrix4f(context, locations.u_matrix),
    'u_texture': new Uniform1i(context, locations.u_texture),
    'u_terrain_coords_id': new Uniform1f(context, locations.u_terrain_coords_id),
    'u_ele_delta': new Uniform1f(context, locations.u_ele_delta)
});
const terrainUniformValues = (matrix, eleDelta) => ({
    'u_matrix': matrix,
    'u_texture': 0,
    'u_ele_delta': eleDelta
});
const terrainDepthUniformValues = (matrix, eleDelta) => ({
    'u_matrix': matrix,
    'u_ele_delta': eleDelta
});
const terrainCoordsUniformValues = (matrix, coordsId, eleDelta) => ({
    'u_matrix': matrix,
    'u_terrain_coords_id': coordsId / 255,
    'u_texture': 0,
    'u_ele_delta': eleDelta
});
export { terrainUniforms, terrainDepthUniforms, terrainCoordsUniforms, terrainPreludeUniforms, terrainUniformValues, terrainDepthUniformValues, terrainCoordsUniformValues };
//# sourceMappingURL=terrain_program.js.map